import CallOutlined from "@mui/icons-material/CallOutlined";
import PresentToAll from "@mui/icons-material/PresentToAll";
import TableRestaurant from "@mui/icons-material/TableRestaurant";
import Videocam from "@mui/icons-material/Videocam";
import { JSX } from "react";
import { MeetingType } from "../api/graphql";

const IconMap: Partial<Record<MeetingType, JSX.Element>> = {
  [MeetingType.VideoCall]: <Videocam />,
  [MeetingType.InPersonVisit]: <TableRestaurant />,
  [MeetingType.Webinar]: <PresentToAll />,
  [MeetingType.VoiceCall]: <CallOutlined />,
};

export default function MeetingTypeIcon({
  meetingType,
}: {
  meetingType: MeetingType;
}) {
  return <>{IconMap[meetingType]}</>;
}
